/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Create_TitleInputs */

const en_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Issue`)
};

const fr_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un nouvel incident`)
};

const de_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Problem erstellen`)
};

const it_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un nuovo problema`)
};

const ru_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый выпуск`)
};

const es_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nuevo problema`)
};

const zh_cn2_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新问题`)
};

const ja_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい問題を作成する`)
};

const hi_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मुद्दा बनाएं`)
};

const pt_pt2_manual_qc_create_title = /** @type {(inputs: Manual_Qc_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo problema`)
};

/**
* | output |
* | --- |
* | "Create New Issue" |
*
* @param {Manual_Qc_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_create_title = /** @type {((inputs?: Manual_Qc_Create_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Create_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_create_title(inputs)
	if (locale === "de") return de_manual_qc_create_title(inputs)
	if (locale === "it") return it_manual_qc_create_title(inputs)
	if (locale === "ru") return ru_manual_qc_create_title(inputs)
	if (locale === "es") return es_manual_qc_create_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_create_title(inputs)
	if (locale === "ja") return ja_manual_qc_create_title(inputs)
	if (locale === "hi") return hi_manual_qc_create_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_create_title(inputs)
	return en_manual_qc_create_title(inputs)
});